import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()((theme) => ({
  root: {
    padding: "0 !important",
    marginTop: "8px",
  },
  // Kept for Instagram lowerComponent compatibility (imports this file)
  cardContent: {
    padding: 0,
    margin: 0,
  },
  tableStyle: {
    borderCollapse: "separate",
    borderSpacing: "0 8px",
    width: "100%",
  },
  // -- Row ---------------------------------------------------------------
  row: {
    backgroundColor: "transparent",
    transition: "background-color 0.2s ease",
  },
  rowCell: {
    padding: 0,
    border: "none",
  },
  rowContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 20px",
    backgroundColor: "#fff",
    borderRadius: "14px",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      borderColor: "rgba(77, 18, 119, 0.15)",
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: "20%",
      bottom: "20%",
      width: "3px",
      borderRadius: "0 2px 2px 0",
      backgroundColor: "transparent",
      transition: "background-color 0.2s ease",
    },
    "&:hover::before": {
      backgroundColor: "#4D1277",
    },
    [theme.breakpoints.down(500)]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "14px",
    },
  },
  // -- Page Info ---------------------------------------------------------
  pageInfo: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  pageAvatar: {
    height: "42px",
    width: "42px",
    borderRadius: "10px",
    backgroundColor: "#f7f7f8",
    border: "1px solid rgba(0,0,0,0.05)",
    flexShrink: 0,
  },
  pageName: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "14.5px",
    color: "#1a1a1a",
    lineHeight: "1.3",
  },
  sourceTag: {
    fontFamily: "Poppins",
    fontSize: "12px",
    color: "#999",
    marginTop: "3px",
    lineHeight: "1",
  },
  // -- Action Buttons ----------------------------------------------------
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
    [theme.breakpoints.down(500)]: {
      width: "100%",
      justifyContent: "flex-end",
    },
  },
  actionBtn: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "12.5px",
    padding: "6px 18px",
    borderRadius: "8px",
    textTransform: "none",
    minWidth: "110px",
    transition: "background-color 0.2s ease, border-color 0.2s ease",
  },
  btnConnect: {
    color: "#4D1277",
    backgroundColor: "rgba(77, 18, 119, 0.04)",
    border: "1px solid rgba(77, 18, 119, 0.14)",
    "&:hover": {
      backgroundColor: "rgba(77, 18, 119, 0.09)",
      borderColor: "rgba(77, 18, 119, 0.3)",
    },
  },
  btnDisconnect: {
    color: "#E34D59",
    backgroundColor: "rgba(227, 77, 89, 0.04)",
    border: "1px solid rgba(227, 77, 89, 0.14)",
    "&:hover": {
      backgroundColor: "rgba(227, 77, 89, 0.09)",
      borderColor: "rgba(227, 77, 89, 0.3)",
    },
  },
  removeBtn: {
    color: "#ccc",
    transition: "all 0.2s ease",
    padding: "8px",
    "&:hover": {
      color: "#E34D59",
      backgroundColor: "rgba(227, 77, 89, 0.05)",
    },
  },
  // -- Modal -------------------------------------------------------------
  modalIcon: {
    height: "48px",
    width: "48px",
    color: "#4D1277",
  },
}));

export default useStyle;
